export const cookieExpiry = () => {
    var currentDate = new Date();
    var expiry = new Date(currentDate.getTime() + 120*60000);
    return expiry;
}